"use strict";

// ПОДКЛЮЧЕНИЕ

// плавный скрол к якорям
let autoScrollToTag = require("./autoScrollToTag");


// НАСТРОЙКИ